// Dependencies
import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'gatsby';

// Components
import Container from '../../../container/container';

// Styles
import CallToActionStyles from './callToAction.styles';

export default function CallToAction({ heading, text, buttons }) {
  return (
    <CallToActionStyles>
      <Container>
        <div className="box">
          <h2 className="heading">{heading}</h2>
          <p className="text">{text}</p>

          {buttons && (
            <div className="btn-group">
              {buttons.map((button) => (
                <Link
                  key={button?.button?.title}
                  to={button?.button?.url}
                  className="btn dark"
                >
                  {button?.button?.title}
                </Link>
              ))}
            </div>
          )}
        </div>
      </Container>
    </CallToActionStyles>
  );
}

CallToAction.propTypes = {
  heading: PropTypes.string,
  text: PropTypes.string,
  buttons: PropTypes.arrayOf(PropTypes.shape({})),
};

CallToAction.defaultProps = {
  heading: '',
  text: '',
  buttons: [],
};
